const BidsEndAsks = () => {
  return <div>BidsEndAsks</div>;
};

export default BidsEndAsks;
